import { presence } from '@/utilities/string';

export default function required(value) {
  if (presence(value)) return null;

  return 'is_required';
}
